import { Form, Formik } from "formik";
import { connect } from "react-redux";
import { Col, Modal, Row } from "react-bootstrap";
import { useEffect, useState } from "react";

import DataTable from "react-data-table-component";
import { shopifyActions } from "../../../../redux/actions";
import ShopifyPresetsMappingModal from "./ShopifyPresetsMappingModal";
import { shopifyPresetsValidationSchema } from "../../../../shared/validationSchema/validationSchema";
import {
  Button,
  SelectField,
  CheckboxField,
  SwitchButton,
  TradeFilters,
  InputNumberField,
} from "../../../../shared/components";
import {
  SET_BY_MARGIN_ENUMS,
  PRODUCT_TYPES_ENUMS,
} from "../../../../system/globalEnums";
import {
  customToast,
  handleSetByChange,
  getFormatedColumns,
  handleCategorySelect,
  getProductMargnColumns,
  getTypeCategoryColumns,
  filterApplyToSearchOptions,
  getMappedShopifyFields,
  handleMapSelectedOptionsInEdit,
  getDefaultFields,
} from "../../../../shared/utility";
import {
  toastType,
  EMPTY_STRING,
  toastMessages,
  shopifyConstants,
  buttonNameConstants,
  buttonTypeConstants,
  SET_BY_MARGIN_OPTIONS,
  tradeInDiscountConstant,
} from "../../../../constants";

const AddNewPreset = (props) => {
  //------- Props destructuring
  const {
    editPreset,
    currentStore,
    initialMappings,
    itemOrganization,
    addShopifyPreset,
    updateShopifyPresets,
    isAddShopifyPresetModal,
    toggleAddShopifyPresetModal,
  } = props;

  const isEdit = editPreset?.id ? true : false;
  const { customTypes, customCategories, customSubCategories } =
    itemOrganization;

  //------- useStates
  const [newMapping, setNewMapping] = useState(initialMappings);
  const [columns, setColumns] = useState([]);
  const [setByFilter, setSetByFilter] = useState();
  const [searchCategories, setSearchCategories] = useState([]);
  const [filterProductType, setFilterProductType] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [modalCheckBoxStatus, setModalCheckBoxStatus] = useState(false);
  const [filterProductCategory, setFilterProductCategory] = useState("");
  const [isShopifyMappingModal, setIsShopifyMappingModal] = useState(false);
  const [defaultCategorySortFieldId, setDefaultCategorySortFieldId] =
    useState();

  //------- Initial values for the modal form
  const initialModalValues = {
    id: editPreset?.id || EMPTY_STRING,
    cashOffer: editPreset?.cashMarginPercentage || EMPTY_STRING,
    tradeOffer: editPreset?.tradeinMarginPercentage || EMPTY_STRING,
    minPrice:
      Number(editPreset?.minPriceRange) >= 0
        ? editPreset?.minPriceRange
        : "0.00",
    maxPrice:
      Number(editPreset?.maxPriceRange) >= 0
        ? editPreset?.maxPriceRange
        : "0.00",
    setBy: editPreset?.type || SET_BY_MARGIN_ENUMS.TYPE.value,
    [shopifyConstants.SEPERATE_QUANTITY]:
      editPreset?.[shopifyConstants.SEPERATE_QUANTITY],

    [shopifyConstants.LINK_TO_SHOPIFY]:
      editPreset?.[shopifyConstants.LINK_TO_SHOPIFY],
    [shopifyConstants.IS_ONLINE_UNIT_SELL_PRICE]:
      editPreset?.[shopifyConstants.IS_ONLINE_UNIT_SELL_PRICE],
  };

  //------- handle SetBy Preset Change
  const handleSetByPresetChange = (option) => {
    handleSetByChange(
      option,
      customTypes,
      setSetByFilter,
      () => {},
      customCategories,
      filterProductType,
      () => {},
      selectedCategories,
      setSearchCategories,
      customSubCategories,
      () => {},
      setSelectedCategories,
      filterProductCategory,
      setModalCheckBoxStatus
    );
  };

  //------- handle table sort
  const onCategoryTableSort = (column, sortDirection) => {
    setColumns(
      columns.map((col) => {
        if (col.id === column.id) {
          return {
            ...col,
            sortDirection,
          };
        } else {
          return {
            ...col,
            sortDirection: null,
          };
        }
      })
    );

    setDefaultCategorySortFieldId(column.id);
  };

  //------- handle switch change
  const handleSwitchChange = (id, checkboxStatus) => {
    setModalCheckBoxStatus(checkboxStatus);
  };

  //------- handle modal handle submit
  const modalHandleSubmit = (data) => {
    if (selectedCategories?.length <= 0) {
      customToast(
        data.setBy === SET_BY_MARGIN_ENUMS.PRODUCT.value
          ? toastMessages.PLEASE_SELECT_PRODUCTS
          : toastMessages.PLEASE_SELECT_CATEGORIES,
        toastType.ERROR
      );
      return;
    }

    let dataToSend = {
      type: setByFilter,
      store: {
        id: currentStore?.id,
        name: currentStore?.storeName,
      },
      isOnlineUnitSellPrice: data[shopifyConstants.IS_ONLINE_UNIT_SELL_PRICE],
      isLinkToShopify: data[shopifyConstants.LINK_TO_SHOPIFY],
      isOnlineQuantity: data[shopifyConstants.SEPERATE_QUANTITY],
      minPriceRange: modalCheckBoxStatus
        ? data.minPrice
        : tradeInDiscountConstant.DEFAULT_MIN_RANGE,
      maxPriceRange: modalCheckBoxStatus
        ? data.maxPrice
        : tradeInDiscountConstant.DEFAULT_MAX_RANGE,
      shopifyMapping: getMappedShopifyFields(newMapping),
    };

    if (data.setBy === SET_BY_MARGIN_ENUMS.TYPE.value) {
      const updatedSelectedCategories = selectedCategories.map((items) => {
        const newObject = {
          productType: items.name,
        };
        return newObject;
      });
      dataToSend = {
        ...dataToSend,
        group: updatedSelectedCategories,
      };
    } else if (data.setBy === SET_BY_MARGIN_ENUMS.CATEGORY.value) {
      const updatedSelectedCategories = selectedCategories.map((items) => {
        const newObject = {
          categoryId: items.id,
          categoryName: items.name,
        };
        return newObject;
      });
      dataToSend = {
        ...dataToSend,
        group: updatedSelectedCategories,
      };
    } else if (data.setBy === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value) {
      const updatedSelectedCategories = selectedCategories.map((items) => {
        const newObject = {
          categoryId: items.id,
          categoryName: items.name,
          parentCategoryId: items.parentCategoryId,
          parentCategoryName: items.parentCategoryName,
        };
        return newObject;
      });
      dataToSend = {
        ...dataToSend,
        group: updatedSelectedCategories,
      };
    }

    if (isEdit) {
      updateShopifyPresets(
        currentStore?.id,
        {
          ...dataToSend,
          id: data.id,
        },
        toggleAddShopifyPresetModal
      );
    } else {
      addShopifyPreset(
        currentStore?.id,
        dataToSend,
        toggleAddShopifyPresetModal
      );
    }
  };

  //------- toggleShopifyMappingModal
  const toggleShopifyMappingModal = () => {
    setIsShopifyMappingModal((prev) => !prev);
  };

  //------ handle save mapping
  const handleSaveMapping = (mappedField) => {
    setNewMapping((prev) => mappedField);
    toggleShopifyMappingModal();
  };

  //------- useEffects
  useEffect(() => {
    setSearchCategories(
      filterApplyToSearchOptions(
        setByFilter,
        customTypes.filter(
          (item) => item.productType !== PRODUCT_TYPES_ENUMS.ALL
        ),
        customCategories,
        customSubCategories,
        filterProductType,
        filterProductCategory,
        selectedCategories
      )
    ); // eslint-disable-next-line
  }, [setByFilter, filterProductType, filterProductCategory]);

  useEffect(() => {
    setColumns([]);
    // eslint-disable-next-line
  }, [currentStore]);

  useEffect(() => {
    handleSetByPresetChange(
      isEdit ? editPreset.type : SET_BY_MARGIN_ENUMS.TYPE.value
    );
    // eslint-disable-next-line
  }, [customCategories]);

  useEffect(() => {
    if (editPreset?.id) {
      setNewMapping(getDefaultFields(editPreset));

      const marginType = editPreset.type;

      handleSetByPresetChange(
        marginType === SET_BY_MARGIN_ENUMS.CATEGORY.value
          ? SET_BY_MARGIN_ENUMS.CATEGORY.value
          : marginType === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value
          ? SET_BY_MARGIN_ENUMS.SUBCATEGORY.value
          : marginType === SET_BY_MARGIN_ENUMS.PRODUCT.value
          ? SET_BY_MARGIN_ENUMS.PRODUCT.value
          : SET_BY_MARGIN_ENUMS.TYPE.value
      );

      setSelectedCategories(
        handleMapSelectedOptionsInEdit(editPreset.group, marginType)
      );

      if (editPreset.minPriceRange >= 0 && editPreset.maxPriceRange >= 0) {
        setModalCheckBoxStatus(true);
      }
      const filterCategory = filterApplyToSearchOptions(
        marginType,
        customTypes.filter(
          (item) => item.productType !== PRODUCT_TYPES_ENUMS.ALL
        ),
        customCategories,
        customSubCategories,
        filterProductType,
        filterProductCategory,
        selectedCategories
      );

      const categoriesNames = editPreset.group.map((row) => {
        return marginType === SET_BY_MARGIN_ENUMS.CATEGORY.value
          ? row.categoryName
          : marginType === SET_BY_MARGIN_ENUMS.SUBCATEGORY.value
          ? row.subcategoryName
          : row.productType;
      });

      setSearchCategories(
        filterCategory.filter((category) => {
          return !categoriesNames.includes(category.name);
        })
      );
    }
    //eslint-disable-next-line
  }, [editPreset]);

  return (
    <>
      <Modal
        show={isAddShopifyPresetModal}
        onHide={toggleAddShopifyPresetModal}
        size="md"
        animation={true}
        centered
        backdrop="static"
        className="add-shopify-preset-modal"
      >
        <Formik
          initialValues={initialModalValues}
          validate={
            modalCheckBoxStatus ? shopifyPresetsValidationSchema : undefined
          }
          onSubmit={modalHandleSubmit}
        >
          {({ values, setFieldValue }) => (
            <Form className="px-0">
              <Modal.Header closeButton>
                <Modal.Title>
                  {!isEdit
                    ? "Add Custom Shopify Configuration"
                    : "Edit Custom Shopify Configuration"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="pt-0">
                <Row className="m-0 p-0">
                  <Col md={12} className="p-0 mb-3">
                    <SelectField
                      name="setBy"
                      label="Set By:"
                      options={SET_BY_MARGIN_OPTIONS}
                      isSearchable={false}
                      placeHolder={"Set By..."}
                      onChangeValue={handleSetByPresetChange}
                      isDisabled={isEdit}
                    />
                  </Col>
                  <p className="p-0">
                    Apply to{" "}
                    {
                      SET_BY_MARGIN_OPTIONS.find(
                        (option) => option.value === values.setBy
                      ).label
                    }
                    :
                  </p>
                  <TradeFilters
                    setBy={values.setBy}
                    customTypes={customTypes}
                    customCategories={customCategories}
                    filterProductType={filterProductType}
                    customSubCategories={customSubCategories}
                    setFilterProductType={setFilterProductType}
                    filterProductCategory={filterProductCategory}
                    setFilterProductCategory={setFilterProductCategory}
                  />
                  <Col md={12} className="p-0 position-relative">
                    <SelectField
                      name="searchOptions"
                      options={searchCategories.map((category) => ({
                        value: category,
                        label: category?.name,
                      }))}
                      isSearchable={true}
                      isSelectedValueAsPlaceholder={false}
                      placeHolder={
                        values.setBy === SET_BY_MARGIN_ENUMS.TYPE.value
                          ? "Search Types"
                          : values.setBy === SET_BY_MARGIN_ENUMS.CATEGORY.value
                          ? "Search Categories"
                          : values.setBy ===
                            SET_BY_MARGIN_ENUMS.SUBCATEGORY.value
                          ? "Search Sub-Categories"
                          : "Search Item"
                      }
                      onChangeValue={(option) => {
                        handleCategorySelect(
                          option,
                          setByFilter,
                          searchCategories,
                          setSearchCategories,
                          selectedCategories,
                          setSelectedCategories,
                          filterProductCategory
                        );
                      }}
                    />
                  </Col>
                  <Col md={12} className="p-0 mt-2">
                    <DataTable
                      className="categories-data-table"
                      columns={getFormatedColumns(
                        values.setBy === SET_BY_MARGIN_ENUMS.PRODUCT.value
                          ? getProductMargnColumns(
                              searchCategories,
                              setSearchCategories,
                              selectedCategories,
                              setSelectedCategories
                            )
                          : getTypeCategoryColumns(
                              searchCategories,
                              setSearchCategories,
                              selectedCategories,
                              setSelectedCategories
                            )
                      )}
                      data={selectedCategories}
                      fixedHeader={true}
                      onSort={onCategoryTableSort}
                      defaultSortFieldId={defaultCategorySortFieldId}
                    />
                  </Col>
                  <Col md={5} className="mt-3 mb-3 p-0">
                    <SwitchButton
                      onSwitchChange={handleSwitchChange}
                      label={"Set Price Range"}
                      id="setpricerange"
                      className="switch-alignment"
                      isSwitchOn={modalCheckBoxStatus}
                    />
                  </Col>
                  <Col
                    md={7}
                    className="d-flex gap-2 mt-2 mb-2 p-0 justify-content-between"
                  >
                    {modalCheckBoxStatus && (
                      <>
                        <Col md={6} className=" ps-0 ">
                          <InputNumberField
                            name="minPrice"
                            placeHolder="Min Price"
                            type="number"
                          />
                        </Col>
                        <Col md={6} className=" pe-0 ">
                          <InputNumberField
                            name="maxPrice"
                            placeHolder="Max Price"
                            type="number"
                          />
                        </Col>
                      </>
                    )}
                  </Col>

                  <Row className=" m-0 offer-percentage-div ">
                    <Col md={12} className="pricing-Text p-0">
                      Default Shopify Configurations:
                    </Col>
                    <Col md={7} className="p-0">
                      <Row>
                        <Col md={12} className="w-100  d-flex my-2">
                          <CheckboxField
                            name={shopifyConstants.LINK_TO_SHOPIFY}
                            label={buttonNameConstants.LINK_TO_SHOPIFY}
                          />
                        </Col>
                        {/* <Col md={12} className="w-100  d-flex my-2">
                          <CheckboxField
                            name={shopifyConstants.IS_ONLINE_UNIT_SELL_PRICE}
                            label={buttonNameConstants.DIFFERENT_ONLINE_PRICE}
                          />
                        </Col> */}
                        <Col md={12} className="w-100 d-flex">
                          <CheckboxField
                            name={shopifyConstants.SEPERATE_QUANTITY}
                            label={buttonNameConstants.SEPARATE_QUANTITY}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col md={5} className="p-0 d-flex align-items-end">
                      <Button
                        type="button"
                        label={buttonNameConstants.EDIT_FIELD_MAPPING}
                        handleClick={() => {
                          toggleShopifyMappingModal();
                        }}
                        className="min-width-btn-trads"
                      />
                    </Col>
                  </Row>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Col md={12} className=" m-0 d-flex gap-2">
                  <Button
                    type="button"
                    label={buttonNameConstants.CANCEL}
                    handleClick={toggleAddShopifyPresetModal}
                    buttonType={buttonTypeConstants.GHOST_BUTTON}
                    className="w-100"
                  ></Button>
                  <Button
                    type="submit"
                    className="w-100"
                    label={
                      isEdit
                        ? buttonNameConstants.UPDATE
                        : buttonNameConstants.SAVE
                    }
                  ></Button>
                </Col>
              </Modal.Footer>{" "}
            </Form>
          )}
        </Formik>
      </Modal>
      {isShopifyMappingModal && (
        <ShopifyPresetsMappingModal
          initialMappings={newMapping}
          handleSaveClick={handleSaveMapping}
          isShopifyMappingModal={isShopifyMappingModal}
          toggleShopifyMappingModal={toggleShopifyMappingModal}
        />
      )}
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  inventory: state.inventory,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
  itemOrganization: state.itemOrganization,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  addShopifyPreset: (storeId, data, toggleAddShopifyPresetModal) =>
    dispatch(
      shopifyActions.createShopifyPreset(
        storeId,
        data,
        toggleAddShopifyPresetModal
      )
    ),
  updateShopifyPresets: (storeId, data, toggleAddShopifyPresetModal) =>
    dispatch(
      shopifyActions.updateShopifyPreset(
        storeId,
        data,
        toggleAddShopifyPresetModal
      )
    ),
});

//-------Export Add Shopify Preset Component
export default connect(mapStateToProps, mapDispatchToProps)(AddNewPreset);
